import { Box, Button, Grid, Tab, Tabs } from "@mui/material";
import { map } from "lodash";
import React from "react";
import { useTranslations } from "use-intl";
import { Description } from "@mui/icons-material";

import style from "./MemberReportConfigTabs.module.scss";

import {
  memberReportConfigTabs,
  MemberReportTabsEnum,
} from "../../services/constant";

interface MemberReportConfigProps {
  tab: MemberReportTabsEnum;
  setTab: (tab: MemberReportTabsEnum) => void;
}

export default function MemberReportConfigTabs({
  tab,
  setTab,
}: MemberReportConfigProps) {
  const t = useTranslations("memberReportConfig");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue as MemberReportTabsEnum);
  };

  return (
    <Box id={style.MemberReportConfigFilter}>
      <Grid container direction="column">
        <Grid item>
          <Tabs
            orientation="vertical"
            value={tab}
            onChange={handleChange}
            sx={{ borderRight: 1, borderColor: "divider" }}
          >
            {map(memberReportConfigTabs, (lct) => (
              <Tab
                sx={{ display: "flex", alignItems: "flex-start" }}
                label={t(`tabs.${lct.value}`)}
                value={lct.value}
                className="dropdown"
                key={lct.value}
              />
            ))}
          </Tabs>
        </Grid>
        <Grid item paddingTop={2} paddingRight={2} paddingBlockEnd={2}>
          <Button
            component="a"
            href={`/reports/enrollment`}
            startIcon={<Description />}
            color="primary"
          >
            {t("tabs.generate")}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
